/**
 * ControlledEventHandler (for inputs, textarea and select)
 * returns onChange and value React property that 2-way binds a DOM control to a binding
 *
 * Requires one argument:
 * @argument binding - the Morearty binding this DOM control will be bound to
 *                       ctrlKey+enterKey (textarea)
 * @argument defaultValue - the React defaultValue property
 *
 * Example
 * ```
 * var ceh = new ControlledEventHandler(binding, defaultValue);
 * MyReactComponent.render = function() {
 *   return (
 *     <React.DOM.input {...Ceh.reactAttributes()} />
 *   )
 * }
 *```
 */

import Morearty from 'morearty';

class ControlledEventHandler {
  constructor(binding, defaultValue, onChange) {
    this.binding = binding;
    this.defaultValue = defaultValue;
    this.onChange = onChange;
  }

  reactAttributes() {
    var value = this.binding.get();
    if (value == null) {
      value = this.defaultValue;
    }
    return {
      onChange: e => {
        Morearty.Callback.set(this.binding)(e);
        if (this.onChange) {
          this.onChange(e);
        }
      },
      value: value || '',
    };
  }
}

export default ControlledEventHandler;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/dom_controls/lib/controlled_binding_event_handler.js